module.exports = __webpack_public_path__ + "static/spanners-6c9615306e2835dff6700c9bec63ee12.png";